export default __webpack_public_path__ + "maps-examples-inset-map-960-ef84fb11fa89e71a2ea3265ecff149fd.png";